import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';

import useActorName from 'shared/hooks/useActorName';
import useActorNames from 'shared/hooks/useActorNames';

// Asks who's using the dashboard the first time it's opened on a browser, so
// the things that get stamped with a name — Watchdog claims, video-editing
// projects — aren't attributed to nobody.
//
// Writes the same persisted actor as the top-bar menu and Google Watchdog
// (sbly-tools:actor-name), so answering here answers everywhere. Attribution
// only, never authorization: it is dismissable and nothing gates on it.
export default function IdentityPrompt() {
  const [actor, setActor] = useActorName();
  const [names, rememberName] = useActorNames();
  const [dismissed, setDismissed] = useState(false);
  const [typed, setTyped] = useState('');

  const choose = (name: string) => {
    const trimmed = name.trim();
    if (!trimmed) return;
    rememberName(trimmed);
    setActor(trimmed);
  };

  return (
    <Dialog open={!actor && !dismissed} onClose={() => setDismissed(true)} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontSize: 18 }}>Who are you?</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" sx={{ color: '#64748B', mb: 2 }}>
          Your name is stamped on what you create and claim across the dashboard.
          It is saved on this browser and you can change it any time from the top
          bar.
        </Typography>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {names.map(name => (
            <Button key={name} size="small" variant="outlined" onClick={() => choose(name)}>
              {name}
            </Button>
          ))}
        </Box>

        <Box sx={{ display: 'flex', gap: 1, mt: 3 }}>
          <TextField
            size="small"
            fullWidth
            label="Someone else"
            value={typed}
            onChange={event => setTyped(event.target.value)}
            onKeyDown={event => {
              if (event.key === 'Enter') choose(typed);
            }}
          />
          <Button
            size="small"
            variant="contained"
            disabled={!typed.trim()}
            onClick={() => choose(typed)}
          >
            Save
          </Button>
        </Box>

        <Button size="small" sx={{ mt: 2 }} onClick={() => setDismissed(true)}>
          Not now
        </Button>
      </DialogContent>
    </Dialog>
  );
}
